class ExperimentsRepository {
  map
  constructor() {
    this.map = {};
  }

  setExperiments(experiments) {
    this.map = {};

    experiments = experiments || [];
    experiments.forEach(function(element) {
      this.map[element.identifier] = element;
    }, this);
  }

  experimentWithName(name) {
    return this.map[name];
  }

  get experiments() {
    return Object.keys(this.map).map(t => this.map[t]);
  }

  experimentForFlagName(flagName) {
    return this.experiments.find(e => e.flags && e.flags.some(f => f.name === flagName));
  }

  experimentForFlag(flag) {
    return this.experimentForFlagName(flag.name);
  }
}

const instance = new ExperimentsRepository();
export default instance;
